import { Backdrop, CircularProgress, Grid, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import useStyles from './useStyles'
import InfoIcon from '@mui/icons-material/Info'
import { useParams } from 'react-router'
import { useDispatch } from 'react-redux'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar
} from '../../../../redux/actions/app'
import { getUserSessions } from '../../../../app/services/sessions/getUserSessions'
import { SessionsList } from './SessionsList'
import { DeleteSession } from '../../../../components/Modals/Sessions/deleteSession'
import CloseIcon from '@mui/icons-material/Close'

export const UserSessions = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [openModal, setopenModal] = useState(false)
  const [sessions, setsessions] = useState([])
  const [uuidDeviceSessions, setuuidDeviceSessions] = useState([])

  const handleClose = () => {
    setopenModal(false)
  }
  const handleOpenModalDeleteSessions = () => {
    setopenModal(true)
  }
  const deleteAllSessions = () => {
    setuuidDeviceSessions(sessions.map((session) => session.uuidDeviceSession))
    handleOpenModalDeleteSessions()
  }
  const getSessions = async () => {
    setLoading(true)
    try {
      const response = await getUserSessions(id)
      if (response?.data?.data) setsessions(response.data.data)
    } catch (error) {
      if (error?.response?.data === 'uuidDeviceSession not exists') { return setLoading(false) }
      dispatch(setRequestTextSnackBar())
      dispatch(
        setErrorTextSnackBar('Ocurrió un error al obtener las sesiones')
      )
    }
    setLoading(false)
  }

  useEffect(() => {
    getSessions()
  }, [id])

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Administrar sesiones activas de un usuario
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá visualizar los dispositivos en los cuales el
          usuario tiene una sesión activa y, asimismo, eliminar dichas sesiones
          si así lo desea.
        </Typography>
      </div>
      <Grid container className={classes.boxDetails}>
        <Grid
          item
          xs={12}
          style={{
            display: ' flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
          }}
        >
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10
            }}
          >
            Dispositivos vinculados {sessions && sessions.length > 0 && 'a ' + sessions[0].email}
          </Typography>
         {sessions && sessions.length > 0 && <button
            className={classes.buttondeleteall}
            onClick={deleteAllSessions}
          >
            <CloseIcon style={{ fontSize: '1rem', color: '#028B7E' }} />
            <Typography className={classes.typographyButton}>
              Eliminar todas las sesiones
            </Typography>
          </button>}
        </Grid>
        <SessionsList
          sessions={sessions}
          setuuidDeviceSessions={setuuidDeviceSessions}
          handleOpenModalDeleteSessions={handleOpenModalDeleteSessions}
        />
      </Grid>
      <DeleteSession
        openModal={openModal}
        handleClose={handleClose}
        uuidDeviceSessions={uuidDeviceSessions}
      />
    </div>
  )
}
